import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-cursor-icon',
  templateUrl: './general-cursor.component.html'
})
export class GeneralCursorComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
